import React from "react";
import { Outlet } from "react-router-dom"; // Import Outlet for nested routes
import AuthContextProvider, { useAuth } from "../lib/contexts/AuthContext";
import Sidebar from "./components/Sidebar";
import { useAdmin } from "../lib/firebase/admin/read";

export default function Layout() {
    return (
        <AuthContextProvider>
            <InnerLayout />
        </AuthContextProvider>
    );
}

function InnerLayout() {
    const { user, isLoading: authIsLoading } = useAuth();
    const { data, error, isLoading } = useAdmin({ uid: user?.uid });

    if (authIsLoading || isLoading) {
        return <h2 className="text-center mt-5">Loading...</h2>;
    }

    if (error) {
        return <p className="text-danger text-center mt-5">{error}</p>;
    }

    if (!data) {
        return (
            <div className="container text-center mt-5">
                <h1 className="text-danger">You are not an admin</h1>
            </div>
        );
    }

    return (
        <div className="container-fluid">
            <div className="row mt-2">
                {/* Sidebar Section */}
                <Sidebar />

                {/* Main Content Section */}
                <main className="col-12 col-md-9 col-lg-10 p-2">
                    <Outlet /> {/* This ensures the correct page is rendered inside Layout */}
                </main>
            </div>
        </div>
    );
}
